import { useState, useEffect } from "react"
import Popup from '../common/popup';
const Freeproduct = (props) => {

 //console.log(props,'props');

  const [show, setShow] = useState(true);
  const [checkedval, setCheckedval] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [freeproductadded, setfreeProductAdded] = useState([]);
  const [freeProductNew,setFreeProductNew] = useState([]);
  const [freeqty, setFreeQty] = useState(0);
  const [productValue, setProductValue] = useState([]);
  const [totalOfferQty, setTotalOfferQty] = useState(0);
  const [referenceQty, setreferenceQty] = useState(0);
  const [freeProductFour, setfreeProductFour] = useState([]);
  const [freeProductFive, setfreeProductFive] = useState([]);
  const [offerproductQty, setofferproductQty] = useState(0);

      useEffect(()=>{

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

        let prodlist = props.freeProduct.data.map(prd=>{return ({pid:prd.productNumber,qty:0})});


        var freeProduct1 = props.freeProduct1;
        setfreeProductFour(freeProduct1);
        var freeProduct2 = props.freeProduct2;
        setfreeProductFive(freeProduct2);

        let prodlist1 = props.freeProduct.data.map(prd=>{return ({...prd,qty:0});});

        var offerProductQtyTotal = 0;
        
        cartItemsNew.map((freeItem)=>{

            if(freeItem.product_type === 'Free'){

               prodlist.map((fre)=>{

                if(fre.pid === freeItem.productNumber){

                    fre.qty = freeItem.qty;
                    offerProductQtyTotal += 4;
                }

            })
            prodlist1.map((fre)=>{

              if(fre.productNumber === freeItem.productNumber){

                  fre.qty = freeItem.qty;
              }

          })

           }

        });

      setFreeProductNew(prodlist1);
      setProductValue(prodlist);
      setofferproductQty(props.productQtyRemaing);

      },[])

    useEffect(()=>{
      if(props.productQty === 4)
      {
        var qtylist = freeProductQtyFour(props.productQty);
        setfreeProductAdded(qtylist);
      }
        
    },[]);


  const handleOnChange = (position,e,productQty) => {

    var inputlimitField = '1';
    var updatedCheckedState = '';

     if(props.freeval !== ''){

         if(productQty === 4){
            updatedCheckedState = checkedState.map((item, index) =>{  
                   if(index === position){ 
                    return !item;
                   }else{
                    return (item === true ? false : false);
                   }
              });
        }else{
            updatedCheckedState = checkedState.map((item, index) =>{  
              var ind = index === position ? !item : item;
              
              return ind;
           });  
        }

        }else{      


           if(productQty === 4){
                updatedCheckedState = checkedState.map((item, index) =>{ 
                       if(index === position){ 
                        return !item;
                       }else{
                        return (item === true ? false : false);

                       }
                  });
            }else{
                updatedCheckedState = checkedState.map((item, index) =>{  
                  var ind = index === position ? !item : item;
                  
                  return ind;
               });  
            }
       }

    var updatedList = [...checkedval];

        if (e.target.checked) {

            if(updatedList.length < 1){

               updatedList = [...checkedval, e.target.value];

            }else{

               //checkedval.splice(0, 1);
               updatedList = [...checkedval, e.target.value];
            }
            
          } else {
            //updatedList = [...checkedval, e.target.value];
            updatedList.splice(checkedval.indexOf(e.target.value), 1);
          }


     setCheckedval(updatedList);

     setCheckedState(updatedCheckedState);
  }

  function priceFormat(price){

     return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
  }


    function freeProductQtyFour(productQty, item){
    
        var divided_by_4 = productQty / props.accountObjective1;
        var firstNum4 = parseInt(divided_by_4);
        return firstNum4;
    }

    function freeProductQtyFive(productQty, item){
        var divided_by_4 = productQty / props.accountObjective1;
        var divided_by_5 = productQty / props.accountObjective2;
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);
        
        if(freeProductFive.includes(item.productNumber)){
            return firstNum5;
        }else{
            return firstNum4;
        }  
    }

    function freeProductQtyTitle(productQty){
        var divided_by_5 = productQty / props.accountObjective2;
        var firstNum5 = parseInt(divided_by_5);
        return firstNum5;    
    }


  function decreaseQty(e,productQty, item,index){

    e.preventDefault();

    var totalOfferQty_value = props.productQtyRemaing;
    var product_qty = parseInt(document.getElementById("input_product_"+item.productNumber).value);
    var offerproductQtyRemaing = localStorage.getItem('offerproductQtyRemaing');
    var incrementLimt = props.accountObjective1;

    if(freeProductFive.includes(item.productNumber)){
        incrementLimt = props.accountObjective2;
    }

    if(productQty == parseInt(props.accountObjective1) && product_qty > 0){
      var divided_by_4 = productQty / props.accountObjective1;
      var firstNum4 = parseInt(divided_by_4);
      document.getElementById("input_product_"+item.productNumber).value = product_qty - 1;
      var minusValue = parseInt(offerproductQtyRemaing) + parseInt(incrementLimt);
      localStorage.setItem('offerproductQtyRemaing', minusValue);
      let tmp_prodval1 = [...freeProductNew];
      let tmp_prodval = productValue;
      tmp_prodval[index].qty = 0;
      tmp_prodval1[index].qty = 0;
     //console.log(tmp_prodval);
      setProductValue(tmp_prodval);
      setFreeProductNew(tmp_prodval1);
      var setdecValue4 = localStorage.getItem('offerproductQtyRemaing');
      setofferproductQty(setdecValue4);      

    }else if(productQty >= props.accountObjective2 && product_qty > 0){

        if(product_qty > 0){
        var qtyNew = 0;
        qtyNew = (product_qty > 0 ? product_qty - 1 : 0);
        document.getElementById("input_product_"+item.productNumber).value = qtyNew;
        let tmp_prodval1 = [...freeProductNew];
        let tmp_prodval = productValue;
        tmp_prodval[index].qty = qtyNew;
        tmp_prodval1[index].qty = qtyNew;
        var minusValue = parseInt(offerproductQtyRemaing) + parseInt(incrementLimt);
        localStorage.setItem('offerproductQtyRemaing', minusValue);
        setProductValue(tmp_prodval);
        setFreeProductNew(tmp_prodval1);
        var setdecValue5 = localStorage.getItem('offerproductQtyRemaing');
        setofferproductQty(setdecValue5);
       }

      }
    }


  function increaseQty(e, productQty, item, index){

    e.preventDefault();

    var product_qty = parseInt(document.getElementById("input_product_"+item.productNumber).value);
    var totalOfferQty_value = props.productQtyRemaing;
    // var returnqty = qtyvalidate(props.productQtyRemaing);
    // var referenceQtyList = returnqty;
    var incrementLimt = props.accountObjective1;
    var offerproductQtyRemaing = localStorage.getItem('offerproductQtyRemaing');

    if(freeProductFive.includes(item.productNumber)){
        incrementLimt = props.accountObjective2;
    }

    if(productQty == props.accountObjective1 && offerproductQtyRemaing >= parseInt(incrementLimt)){
        var divided_by_4 = productQty / props.accountObjective1;
        var firstNum4 = parseInt(divided_by_4);
        document.getElementById("input_product_"+item.productNumber).value = firstNum4;
        var minusValue = offerproductQtyRemaing - parseInt(incrementLimt);
        localStorage.setItem('offerproductQtyRemaing', minusValue);
        let tmp_prodval1 = [...freeProductNew];
        let tmp_prodval = productValue;
        tmp_prodval[index].qty = firstNum4;
        tmp_prodval1[index].qty = firstNum4;
        //console.log(tmp_prodval);
        totalOfferQty_value = totalOfferQty_value - props.accountObjective1;
        setProductValue(tmp_prodval);
        setFreeProductNew(tmp_prodval1);
        var setValue = localStorage.getItem('offerproductQtyRemaing');
        setofferproductQty(setValue);

    }else if(productQty >= props.accountObjective2 && offerproductQtyRemaing >= parseInt(incrementLimt)){
        var qty = 0;
        qty = product_qty + 1;
        document.getElementById("input_product_"+item.productNumber).value = qty;
        var minusValue = offerproductQtyRemaing - parseInt(incrementLimt);
        localStorage.setItem('offerproductQtyRemaing', minusValue);
        let tmp_prodval1 = [...freeProductNew];
        let tmp_prodval = productValue;
        tmp_prodval[index].qty = qty;
        tmp_prodval1[index].qty = qty;
        setProductValue(tmp_prodval);
        setFreeProductNew(tmp_prodval1);
        var setValue5 = localStorage.getItem('offerproductQtyRemaing');
        setofferproductQty(setValue5);
    }

  }

console.log(offerproductQty, 'offerproductQty');

console.log(props.accountObjective1, 'props.accountObjective1');
  
console.log(parseInt(offerproductQty) < parseInt(props.accountObjective1), 'offerproductQty < props.accountObjective1');

  // console.log(freeProductNew, 'freeProductNew');
  // console.log(freeProductFour, 'freeProductFour');

  return (<div>
    <Popup extClass ="info-poup free-prod-wrap show" id='free-prod-wrap'
            closebtn={<></>}
            headMoreTxt={
                <>
                <span onClick={props.closefreepro} className='close free_product_popup'></span>

                { props.productQty < props.accountObjective1  && 
                    <div className="order-top">
                       <h4>FREE Option<span>To avail FREE pasta or FREE rice you are required to select min. {props.accountObjective1} or {props.accountObjective2} sauces of your choice.</span></h4>
                    </div>
                 }

                { props.productQty == props.accountObjective1 && 
                    <div className="order-top">
                        {props.productQty == props.accountObjective1 && 
                         <h4>FREE Option<span>When you select any {props.productQty} sauces you will receive 1 x FREE pasta</span></h4>}
                    </div>
                 }

                 { props.productQty <= 8 && 
                    <div className="order-top">
                        {props.productQty > props.accountObjective1 ?
                        <h4>FREE Option <span>When you select any {props.productQty} sauces you will receive {freeProductQtyFour(props.productQty)} x FREE pasta </span> <span> or {freeProductQtyTitle(props.productQty)} x FREE rice </span></h4>
                        : ''}
                    </div>
                 }

                 {props.productQty >= 9 && 
                    <div className="order-top">
                       <h4> FREE Option <span>When you select any {props.productQty} sauces you will receive {freeProductQtyFour(props.productQty)} x FREE pasta </span> <span> or {freeProductQtyTitle(props.productQty)} x FREE rice or a combination of both</span></h4>
                    </div>
                 }
                 
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="checkout-table free-prod-pop">
                        <div className="table_overflow">
                            <table>
                                <thead>
                                    <tr>
                                        <td data-title='Product'>Product</td>
                                        <td data-title='Unit of Sale'>Unit of Sale</td>
                                        <td data-title='Price'>Price</td>
                                        <td align='center' data-title='Quantity'>Quantity</td>
                                    </tr>
                                </thead>
                                <tbody>


                                {parseInt(props.productQty) < parseInt(props.accountObjective1) && freeProductNew.map((item, index) => {

                                    if(freeProductFour.includes(item.productNumber)){
                                     return( <tr>

                                             <td data-title="Product">
                                                        <label for={"freecheckbox_"+item.productNumber}>{item.productDescription} ({item.productNumber})</label>
                        
                                                </td>
                                                <td data-title="Unit of Sale"><p><strong>{item.packageSize}</strong></p></td>
                                                <td data-title="Price"><p  className='color-red'><strong>FREE</strong></p></td>
                                                <td align='center' data-title="Quantity">
                                            
                                                  <div className='free-prod-qty-val'>
                                                    <span className="qty-val-action qty-val-minus">-</span>
                                                    <input type="text" value={item.qty} />
                                                    <span className="qty-val-action qty-val-plus">+</span>
                                                  </div>
                                                </td>
                                              
                                                </tr>
                                  )
                                  }
                                })}


                                {parseInt(props.productQty) == parseInt(props.accountObjective1) && freeProductNew.map((item, index) => {

                                    if(freeProductFour.includes(item.productNumber)){
                                     return( <tr>

                                             <td data-title="Product">
                                              <label for={"freecheckbox_"+item.productNumber}>{item.productDescription} ({item.productNumber})</label>
                        
                                                </td>
                                                <td data-title="Unit of Sale"><p><strong>{item.packageSize}</strong></p></td>
                                                <td data-title="Price"><p  className='color-red'><strong>FREE</strong></p></td>
                                                <td align='center' data-title="Quantity" className={parseInt(props.accountObjective1) > parseInt(offerproductQty) && item.qty == 0 ? 'disabled' : ''}>
                                                  <div className='free-prod-qty-val'>
                                                    <span className="qty-val-action qty-val-minus" onClick={(e) =>decreaseQty(e,props.productQty,item,index)}>-</span>
                                                    <input type="text" id={"input_product_"+item.productNumber} value={item.qty} />
                                                    <span className="qty-val-action qty-val-plus" onClick={(e) =>increaseQty(e,props.productQty,item,index)}>+</span>
                                                  </div>
                                                </td>
                                              
                                                </tr>
                                  )
                              }
                                 })}

                                {parseInt(props.productQty) > parseInt(props.accountObjective1) && freeProductNew.map((item, index) => {
                
                                   return( <tr>
                                            <td data-title="Product">
                                             <label for={"freecheckbox_"+item.productNumber}>{item.productDescription} ({item.productNumber})</label>
                                            </td>
                                            <td data-title="Unit of Sale"><p><strong>{item.packageSize}</strong></p></td>
                                            <td data-title="Price"><p  className='color-red'><strong>FREE</strong></p></td>
                                            <td align='center' data-title="Quantity" className={parseInt(props.accountObjective1) > parseInt(offerproductQty) && item.qty == 0  ? 'disabled' : ''}> 
                                              <div className='free-prod-qty-val'>
                                                <span className="qty-val-action qty-val-minus" onClick={(e) =>decreaseQty(e,props.productQty,item, index)}>-</span>
                                                <input type="text" id={"input_product_"+item.productNumber} value={item.qty} />
                                                <span className="qty-val-action qty-val-plus" onClick={(e) =>increaseQty(e,props.productQty,item,index)}>+</span>
                                              </div>
                                           </td>
                                        </tr>)
                                 })}
                    
                    
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="info-bdy offer_products">

                                          
                       <div className="alert-message">
                            <p id='alert_message'></p>
                       </div>
                      

                     <div className="btn-item">
                            <div className="info-innr">
                            <button type='button' onClick={(e) =>props.addfreepro(e,checkedval,props.freeProduct,productValue, freeProductNew, checkedState)} >Add To Cart</button>
                            </div>
                    </div>

                   <span className="free-edit-desp">You can add/change your FREE product anytime using the add/edit icon setting<span className="required">*</span></span>
                 </div>
                </>
            }
        />
    </div>

  )
}

export default Freeproduct;
